import { render, staticRenderFns } from "./InstallationProjects.vue?vue&type=template&id=2aa70b1c&scoped=true"
import script from "./InstallationProjects.vue?vue&type=script&lang=js"
export * from "./InstallationProjects.vue?vue&type=script&lang=js"
import style0 from "./InstallationProjects.vue?vue&type=style&index=0&id=2aa70b1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa70b1c",
  null
  
)

export default component.exports